module.exports = __webpack_public_path__ + "static/media/place.d546ec00.svg";